import { mapActions, mapState } from 'vuex'
import { useApi } from '@/services/api'
import { Usuarios } from '@/stores/usuarios'
import { GetLocalDelegacao, SetLocalDelegacao } from '@/localStorage'
import './scss/style.scss'

export default {
   name: 'GrupoUsuario',

   async created() {
      await this.usuarios.ActionObterUserInfoNc()

      if (this.usuarios.userInfo && this.usuarios.userInfo.grupos) {
         this.gruposUsuario = this.usuarios.userInfo.grupos.filter(grupo => grupo.gestorId !== null);
      } else {
         this.gruposUsuario = []; 
      }

      if (GetLocalDelegacao()) {
         this.grupoSelecionado = GetLocalDelegacao()
         return
      }

      if (this.gruposUsuario && this.gruposUsuario.length > 0) {
         this.grupoSelecionado = this.gruposUsuario[0].gestorId
         SetLocalDelegacao(this.grupoSelecionado)
      } else {
         this.grupoSelecionado = null;
      }
   },

   data() {
      return {
         usuarios: Usuarios(),
         userService: null,

         form: {},
         grupoSelecionado: null,
         gruposUsuario: [] 
      }
   },

   methods: {
      async recarregar() {
         if (!this.grupoSelecionado) return;
         
         const { api } = useApi();
         
         SetLocalDelegacao(this.grupoSelecionado)         
         await this.usuarios.ActionCarregarInfo(this.grupoSelecionado)

         //this.$router.push('/home')
         window.location.href = '/';
      }
   }
}